import React from 'react';
import PropTypes from 'prop-types';
import {Spinner, Spacer} from '@te-digi/styleguide';

const LoadingIndicator = ({center, small}) => {
  if (small) {
    return (
      <div className="loading-indicator-wrapper">
        <Spinner size="sm" />
      </div>
    );
  }
  if (center) {
    return (
      <Spacer marginTop="md" marginBottom="md">
        <Spinner align="center" />
      </Spacer>
    );
  }
  return <Spinner />;
};

LoadingIndicator.propTypes = {
  center: PropTypes.bool,
  small: PropTypes.bool
};

export default LoadingIndicator;
